import { render, staticRenderFns } from "./table4.vue?vue&type=template&id=b27a6a7a&scoped=true"
import script from "./table4.vue?vue&type=script&lang=js"
export * from "./table4.vue?vue&type=script&lang=js"
import style0 from "./table4.vue?vue&type=style&index=0&id=b27a6a7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27a6a7a",
  null
  
)

export default component.exports